import React, {useState, Suspense, useRef} from "react";
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIInputMask from 'components/input/UIInputMask';

//import UIDataTable from 'components/datatable/UIDataTable';
import moment from "moment";
import CommonUtil from "utils/CommonUtil";
import ValidationUtil from "common/validation/util/ValidationUtil";
import CorperationManageModel from "../adm_4212/model/CorperationManageModel";
import TbCommCorpBizLic from "domain/main/comm/corp/biz/lic/TbCommCorpBizLic";
import UIFileDownload from "components/file/UIFileDownload";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UIUtils from "utils/UIUtils";
import StringUtil from 'utils/StringUtil';
import DateUtil from "utils/DateUtil";
import commonPopupStore from "../../../../common/popup/store/CommonPopupStore";
import UIDataTable from "../../../../components/datatable/UIDataTable";
import userStore from "common/user/store/UserStore";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";
import {upload} from "@testing-library/user-event/dist/upload";


function ContentsContainer() {
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();
	const [modaladm4211Open, setModaladm4211Open] = useState(false); //사업자등록증  팝업오픈여부
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);  //파일업로드 

    const model: CorperationManageModel = new CorperationManageModel;
	const [corpInfo, setCorpInfo] = useState({});
	
    const [bizNo, setBizNo] = useState("");
	const [corpSizeCd,setCorpSizeCd] = useState('');
	const [corpSizeCdNm,setCorpSizeCdNm] = useState('');
	const [acctNo,setAcctNo] = useState('');
	const [refundAcctNo,setRefundAcctNo] = useState('');
	const [corpNm,setCorpNm] = useState('');
	const [induCd,setInduCd] = useState('');
	const [induCdNm,setInduCdNm] = useState('');
	const [corpRegNo,setCorpRegNo] = useState('');
	const [ceoNm,setCeoNm] = useState('');
	const [evalDivCd,setEvalDivCd] = useState('');
	const [evalDivCdNm,setEvalDivCdNm] = useState('');
	const [evalCd,setEvalCd] = useState('');
	const [evalCdNm,setEvalCdNm] = useState('');
	const [grpNm,setGrpNm] = useState('');
	const [estaDate,setEstaDate] = useState('');
	const [estaFormCd,setEstaFormCd] = useState('');
	const [estaFormCdNm,setEstaFormCdNm] = useState('');
	const [corpZipCd,setCorpZipCd] = useState('');
	const [corpAddr,setCorpAddr] = useState('');
	const [corpAddr1,setCorpAddr1] = useState('');
	const [corpAddr2,setCorpAddr2] = useState('');
	const [homepageUrl,setHomepageUrl] = useState('');
	const [regNm,setRegNm] = useState('관리자');
	const [regDate,setRegDate] = useState('');
	const [prvtMngr,setPrvtMngr] = useState('');
    
	//파일정보 선언 
	let [corpLogoFileValue] = useState(new TbComFile());
	let [bizLicFileValue] = useState(new TbComFile());

	// 폼체크 여부 
	const [formCheck,setFormCheck] = useState(false);  
	const [loadFinish,setLoadFinish] = useState(false);

	//날짜 0 처리 
    function dateLpad(num){
		let strNum = num;
		if(strNum.length == 1){
			strNum = "0"+strNum;
		}

		return strNum;
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(String(month))+'-'+dateLpad(String(day))+'('+dayName+')';
	}

	async function initCall(bizNo){
		
		let param = {
			"BIZ_NO": bizNo
		};

		const response:any = await CommonUtil.execute({
			url:'adm_4210',
			data: param
		})

		const result = response;
		setCorpInfo(result);

		setBizNo(result.BIZ_NO);
		setCorpSizeCd(result.CORP_SIZE_CD);
		setCorpSizeCdNm(result.CORP_SIZE_CD_NM);
		setCorpNm(result.CORP_NM);
		setInduCd(result.INDU_CD);
		setInduCdNm(result.INDU_CD_NM);
		setCorpRegNo(result.CORP_REG_NO);
		setCeoNm(result.CEO_NM);
		setEvalDivCd(result.EVAL_DIV_CD);
		setEvalDivCdNm(result.EVAL_DIV_CD_NM);
		setEvalCd(result.EVAL_CD);
		setEvalCdNm(result.EVAL_CD_NM);
		setGrpNm(result.GRP_NM);
		setEstaDate(dateToStr(result.ESTA_DATE));
		setEstaFormCd(result.ESTA_FORM_CD);
		setEstaFormCdNm(result.ESTA_FORM_CD_NM);
		setCorpZipCd(result.CORP_ZIP_CD);
		setAcctNo(result.ACCT_NO);
		setRefundAcctNo(result.REFUND_ACCT_NO);
		let addr1 = "";
		let addr2 = "";
		if(result.CORP_ADDR_1 != null){
			addr1 = result.CORP_ADDR_1;
		}
		if(result.CORP_ADDR_2 != null){
			addr2 = result.CORP_ADDR_2;
		}
		let addr = addr1 +" "+ addr2
		setCorpAddr(addr);
		setCorpAddr1(result.CORP_ADDR_1);
		setCorpAddr2(result.CORP_ADDR_2);
		setHomepageUrl(result.HOMEPAGE_URL);
		setPrvtMngr(result.PRVT_MNGR);
		setRegNm(result.REG_NM);
		setRegDate(dateToStr(result.REG_DATE));
		//가상계좌확인서가 있을경우
        if(result.FILE_INFO != null){
			let fileInfo = result.FILE_INFO;
			//파일등록 정보
			fileInfo?.map((vacctFileInfo, index) => {
				if(vacctFileInfo.DWLD_ID !=null){
					const vacctChkDetail = new TbComFileMapngDetail();
					vacctChkDetail.setDwldId(vacctFileInfo.DWLD_ID);
					vacctChkDetail.setFileDetailId(vacctFileInfo.FILE_DETAIL_ID);
					vacctChkDetail.setFilePolicy(vacctFileInfo.FILE_POLICY);
					vacctChkDetail.setFileRpstr(vacctFileInfo.FILE_RPSTR);
					vacctChkDetail.setStrePath(vacctFileInfo.STRE_PATH);
					vacctChkDetail.setStreFileNm(vacctFileInfo.STRE_FILE_NM);
					vacctChkDetail.setOrginlFileNm(vacctFileInfo.ORGINL_FILE_NM);
					vacctChkDetail.setFileExtsn(vacctFileInfo.FILE_EXTSN);
					vacctChkDetail.setFileSize(vacctFileInfo.FILE_SIZE);
					vacctChkDetail.setRegistPsnNm(vacctFileInfo.REGIST_PSN_NM);
					vacctChkDetail.setRegistDt(vacctFileInfo.REGIST_DT);

					corpLogoFileValue.putTbComFileMapngDetailList(vacctChkDetail);
				}
			});
		}

		//사업자 등록증이 있을경우
		if(result.BIZLIC_INFO != null){
            let bizFileInfo = result.BIZLIC_INFO;
			//파일등록 정보
			bizFileInfo?.map((bizFileInfo, index) => {
				if(bizFileInfo.DWLD_ID !=null){
					const bizLicDetail = new TbComFileMapngDetail();
					bizLicDetail.setDwldId(bizFileInfo.DWLD_ID);
					bizLicDetail.setFileDetailId(bizFileInfo.FILE_DETAIL_ID);
					bizLicDetail.setFilePolicy(bizFileInfo.FILE_POLICY);
					bizLicDetail.setFileRpstr(bizFileInfo.FILE_RPSTR);
					bizLicDetail.setStrePath(bizFileInfo.STRE_PATH);
					bizLicDetail.setStreFileNm(bizFileInfo.STRE_FILE_NM);
					bizLicDetail.setOrginlFileNm(bizFileInfo.ORGINL_FILE_NM);
					bizLicDetail.setFileExtsn(bizFileInfo.FILE_EXTSN);
					bizLicDetail.setFileSize(bizFileInfo.FILE_SIZE);
					bizLicDetail.setRegistPsnNm(bizFileInfo.REGIST_PSN_NM);
					bizLicDetail.setRegistDt(bizFileInfo.REGIST_DT);

					bizLicFileValue.putTbComFileMapngDetailList(bizLicDetail);
				}
			})			
		}

		//console.log("bizLicFileValue : "+JSON.stringify(bizLicFileValue));
		setLoadFinish(true);
	};

	//init 
	React.useEffect(() => {
		//필요한 공통코드 로딩.
		codeDataStore.read("/system.personmanage/utcAll", "/common/yesNo").then(()=>{

			 //넘어온 파라미터 바인딩   
			if(receivedData != undefined){
				let bizNo = StringUtil.defaultString(receivedData.vBIZ_NO);
				setBizNo(bizNo)
				localStorage.setItem("bizNo", bizNo);
			}
			
			let bizNoStorage = localStorage.getItem("bizNo");
			if (bizNoStorage != null) {
				setBizNo(bizNoStorage);
			}
			
			
			//상세데이터 가지고 오기
			initCall(bizNoStorage);

		});
	
	}, [])//effect

	

	//상세정보 값 가지고 오기
	function getInfo(name){
		if(Object.keys(corpInfo).length != 0){
			return corpInfo[name];
		}else{
			return '';
		}
	};

	/**
   * 사업자등록증 등록/갱신
   */
	//const [uploadId, setUploadId] = React.useState("");
	let uploadId = useRef<string>("");

	//파일업로드 
    const onCreationComplete = function (uploadID: string) {
        uploadId.current = uploadID;
        console.log(uploadId.current);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId.current);
        const arrayNew = dataArray.newFile;
       // const arrayDel = dataArray.deleteFile;
	
		let fileInfos : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		}[] = [];

		let fileInfo : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		};

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
				}

				fileInfos.push(fileInfo);
			}
		})

		setFileInfoList(fileInfos);

    }


	//사업자등록증 저장 파일업로드 
	async function formCheck4210() {
		const fileCount =  window["RAONKUPLOAD"].GetTotalFileCount(uploadId.current);
		
		if(fileCount == 0){
			await UIUtils.alert('업로드 파일이 없습니다.');
			return;
		}
		
		setFormCheck(true);
		onFileUpload();
			
	}

	
	const onFileUpload = () => {
		if(uploadId.current){
			window["RAONKUPLOAD"].Transfer(uploadId.current);
		}
	}

	// 파일 업로드 성공여부 체크
	React.useEffect(() => {
		if(fileInfoList && formCheck) {
			// 파일 업로드 성공
			let param = {
				"BIZ_NO":bizNo
				,"FILE_INFO_LIST":fileInfoList
			}
			
			//사업자등록증 저장 
			doTransfer(param);
			
		}
	}, [fileInfoList])

	//사업자등록증 등록/갱신
	async function doTransfer(sendParam:any) {
		const response: any = await CommonUtil.execute({
			url: 'createBizLicense',
			data: sendParam
		}).then((response: any) => {
			if(response){
				UIUtils.alert('저장되었습니다.').then(() => {
					setFormCheck(false);
					setModaladm4211Open(false);

					//초기화
					bizLicFileValue.tbComFileMapngDetailList = [];

					initCall(bizNo);
				});
			}
		}).catch(err => {
			CommonUtil.showAxiosError(err);
			return;
		});
		
	} 

	async function handleClose(){
		//window["RAONKUPLOAD"].Destroy(uploadId.current)
		console.log(uploadId.current)
		setModaladm4211Open(false);
	}

    //목록으로
    const goList = () => {
        history.push({
            pathname: './adm4200',
            state: {data: receivedData}
        });
    }

	//수정 페이지로 이동
	const corpInfoUpdate = function (){
        let dataToSend = {};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
		pathname: './adm4213',
		state: { data: receivedData }
		});
	}
    
	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">사용자관리</Link></li>
					<li><Link to="#">기업관리</Link></li>
				</ul>

				<main className="fww-main">
					<h1 className="tx tx-hd2">기업상세</h1>
					<h2 className="tx tx-hd3">기본정보</h2>
					<div className="fo fo-col2">
						<div className="inner">
							<div className="fo-item"> 
								<p className="fo-key">기업규모</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpSizeCdNm} valueChanged={(value) => setCorpSizeCdNm(value)}  placeholder={''} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">업종</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={induCdNm} valueChanged={(value) => setInduCdNm(value)}  placeholder={''} readOnly={true}/>
								</div>						
							</div>
							
							<div className="fo-item">
								<p className="fo-key">법인등록번호</p>
								<div className="fo-value">
									<UIInputMask
										mask={"999999-9999999"}
										className={'tf tf-md w100p'} 
										value={corpRegNo}
										valueChanged={(value) => setCorpRegNo(value)}
										readOnly={true}
										/>
								</div>						
							</div>
							<div className="fo-item"> 
								<p className="fo-key">사업자등록번호</p>
								<div className="fo-value">
									<UIInputMask
										mask={"999-99-99999"}
										className={'tf tf-md w100p'} 
										value={bizNo}
										valueChanged={(value) => setBizNo(value)}
										readOnly={true}
										/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">기업명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpNm} valueChanged={(value) => setCorpNm(value)} placeholder={''} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">대표자명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={ceoNm} valueChanged={(value) => setCeoNm(value)} placeholder={''} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item"> 
								<p className="fo-key">평가구분</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={evalDivCdNm} valueChanged={(value) => setEvalDivCdNm(value)} placeholder={''} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">평가</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={evalCdNm} valueChanged={(value) => setEvalCdNm(value)} placeholder={''} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">집단</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={grpNm} valueChanged={(value) => setCorpNm(value)} placeholder={''} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item"> 
								<p className="fo-key">설립일자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={estaDate} valueChanged={(value) => setEstaDate(value)} placeholder={''} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">설립형태</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={estaFormCdNm} valueChanged={(value) => setEstaFormCdNm(value)} placeholder={''} readOnly={true}/>
								</div>						
							</div>
							
							{/*<div className="fo-item">
								<p className="fo-key">홈페이지</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={homepageUrl} valueChanged={(value) => setHomepageUrl(value)} placeholder={''} readOnly={true}/>
								</div>						
							</div>*/}
							<div className="fo-item">
								<p className="fo-key">민간자율 기획사업 담당자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={prvtMngr} valueChanged={(value) => setPrvtMngr(value)} placeholder={''} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">주소</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpAddr} valueChanged={(value) => setCorpAddr(value)} placeholder={''} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">출연계좌</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={acctNo}  valueChanged={(value) => setAcctNo(value)}  placeholder={''} readOnly={true}/>
								</div>
								<p className="fo-key">환수계좌</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={refundAcctNo}  valueChanged={(value) => setRefundAcctNo(value)}  placeholder={''} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">가상계좌확인서</p>
								<div className="fo-value">
									<div className='w100p'>
										<Suspense fallback={<PageLoading/>}>
                                            <UI.FileDownload value={corpLogoFileValue !=null?corpLogoFileValue:new TbComFile}/>
                                        </Suspense>
									</div>
								</div>
							</div>								
							<div className="fo-item">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={regNm} valueChanged={(value) => setRegNm(value)}  placeholder={''} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={regDate} valueChanged={(value) => setRegDate(value)}  placeholder={''} readOnly={true}/>
								</div>						
							</div>								
						</div> 
					</div>								
					<h2 className="tx tx-hd3">사업자등록증 이력</h2>
					<div className="tb-view-file">
						<UI.FileDownloadSimpleMode value={bizLicFileValue} viewMode={"bizLic"} rowNumber={true}/>
					</div>

					<div className="hz-root hz-right hz-gap5">
						<Button color="pri-o" size="sm" onClick={()=>setModaladm4211Open(true)}>사업자등록증 등록/경신</Button>
						<Button color="pri-o" size="sm" onClick={corpInfoUpdate}>수정</Button>
						<Button color='gray-o' size="sm" onClick={goList}>목록</Button>
					</div>
				</main>
				
			</div>

			<ModalPopup
				open={modaladm4211Open}
				title="사업자등록증 등록/갱신"
				size="mid"
				onClose={() => handleClose()}
				onAfterClose={()=>{commonPopupStore.closeLastPopup();}}
			    >
				<div className="modal-con">
					<UI.FileUpload
						onCreationComplete={onCreationComplete}
						onUploadComplete={onUploadComplete}
						attrs={{
							MaxTotalFileCount: "1",
							ExtensionAllowOrLimit: "1",
							ExtensionArr: "pdf"
						}}
					/>
				</div>
				<div className="modal-bottom">
					<Button color='pri' size="md" onClick={formCheck4210}>등록/갱신</Button>
				</div>
			</ModalPopup>
			
		</PageContainer>
	);
}
export default ContentsContainer;
